import { RfqRegisterList } from "./RfqRegisterList";
import { RfqRegisterCreate } from "./RfqRegisterCreate";
import { RfqRegisterEdit } from "./RfqRegisterEdit";

export default {
  list: RfqRegisterList,
  create: RfqRegisterCreate,
  edit: RfqRegisterEdit,
};